import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PublicFooter from '../ui/PublicFooter'
import { api } from '../lib/api'

function useQuery() {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}

export default function ResetPasswordPage() {
  const q = useQuery()
  const navigate = useNavigate()
  const token = q.get('token') || ''

  const [pw, setPw] = React.useState('')
  const [pw2, setPw2] = React.useState('')
  const [busy, setBusy] = React.useState(false)
  const [error, setError] = React.useState(null)
  const [done, setDone] = React.useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()
    setError(null)

    if (!token) {
      setError('재설정 토큰이 없습니다. 메일의 링크를 다시 확인해 주세요.')
      return
    }
    if (!pw || pw.length < 8) {
      setError('비밀번호는 8자 이상으로 입력해 주세요.')
      return
    }
    if (pw !== pw2) {
      setError('비밀번호 확인이 일치하지 않습니다.')
      return
    }

    setBusy(true)
    try {
      const res = await api.post('/auth/password/reset/confirm', {
        token,
        newPassword: pw,
        newPasswordConfirm: pw2,
      })
      const payload = (res?.data && res.data.data !== undefined) ? res.data.data : res.data
      if (payload?.changed) {
        setDone(true)
        // 토큰이 URL에 남지 않게 정리
        try { window.history.replaceState({}, '', '/reset-password') } catch {}
        // 2초 후 로그인으로 이동
        setTimeout(() => navigate('/login'), 1200)
      } else {
        setError('비밀번호 재설정에 실패했습니다. 링크가 만료되었을 수 있습니다.')
      }
    } catch (e2) {
      setError('비밀번호 재설정에 실패했습니다. 링크가 만료되었을 수 있습니다.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm space-y-4 p-6 border rounded-lg bg-white">
          <h1 className="text-xl font-semibold">비밀번호 재설정</h1>
          {done ? (
            <div className="space-y-3">
              <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded px-3 py-2">
                비밀번호가 변경되었습니다. 잠시 후 로그인 화면으로 이동합니다.
              </div>
              <Link className="inline-flex text-sm underline text-brand-navy" to="/login">로그인으로 이동</Link>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-3">
              {error && <div className="text-red-600 text-sm">{error}</div>}
              <div>
                <label className="block text-sm text-slate-600">새 비밀번호</label>
                <input
                  className="mt-1 w-full rounded border px-3 py-2"
                  type="password"
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  autoComplete="new-password"
                  required
                />
              </div>
              <div>
                <label className="block text-sm text-slate-600">새 비밀번호 확인</label>
                <input
                  className="mt-1 w-full rounded border px-3 py-2"
                  type="password"
                  value={pw2}
                  onChange={(e) => setPw2(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                {pw && pw2 && pw !== pw2 && (
                  <div className="text-xs text-red-600 mt-1">비밀번호 확인이 일치하지 않습니다.</div>
                )}
              </div>
              <button
                className="w-full rounded bg-brand-navy text-white py-2 disabled:opacity-50"
                type="submit"
                disabled={busy}
              >
                {busy ? '변경 중…' : '비밀번호 변경'}
              </button>
              <div className="text-xs text-slate-500">
                링크가 만료되었거나 문제가 있으면 다시 “비밀번호 찾기”를 진행해 주세요.
              </div>
            </form>
          )}
        </div>
      </main>
      <PublicFooter />
    </div>
  )
}

